import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API, withCredentials: true });

export const sendInquiry = (payload) => http.post("/inquiries", payload).then((r) => r.data);
export const exchangeSession = (session_id) => http.post("/auth/session", { session_id }).then((r) => r.data);
export const getMe = () => http.get("/auth/me").then((r) => r.data);
export const logout = () => http.post("/auth/logout").then((r) => r.data);
export const listInquiries = () => http.get("/inquiries").then((r) => r.data);
export const updateInquiryStatus = (id, status) => http.patch(`/inquiries/${id}/status`, { status }).then((r) => r.data);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
